'use client';

import { cn } from '@eliadmin/core/src/utils/style-utils';
import { useLocaleStore } from '@eliadmin/core/src/stores/locale-store';
import { GoArrowUp } from 'react-icons/go';
import { Button } from '../ui/button';

const labels: Record<string, string> = {
  sk: 'Na začiatok stránky',
  cs: 'Na začátek stránky',
  cz: 'Na začátek stránky',
  pl: 'Na początek strony',
  hu: 'Az oldal tetejére',
  de: 'Zum Seitenanfang',
  en: 'Back to top',
};

export function ScrollToTop() {
  const locale = useLocaleStore(state => state.currentLocale);
  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth',
    });
  };

  return (
    <Button
      size={'icon'}
      aria-label={
        labels[(locale ?? 'en').replaceAll('_', '-').split('-')[0].toLowerCase()] ?? labels.en
      }
      onClick={scrollToTop}
      className={cn(
        'ea-scroll-to-top',
        'fixed bottom-28 right-4 z-[40] flex h-[50px] w-[50px] cursor-pointer items-center justify-center rounded-full bg-primary text-white opacity-100 transition-all hover:bg-primary/80',
        // {
        //   'opacity-0': window.scrollY < 200,
        // },
      )}
    >
      <GoArrowUp size={24} aria-hidden="true" />
    </Button>
  );
}
